module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "button-bar"
  }, [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": '/clients/' + _vm.currentClientId
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  }), _vm._v(" Back to Client")])], 1), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    staticStyle: {
      "max-width": "600px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('form-group', {
    attrs: {
      "label": "Report Title",
      "col-class": "col-md-4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.report_title),
      expression: "report.report_title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.report.report_title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.report.report_title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Report Issue Date",
      "col-class": "col-md-4"
    }
  }, [_c('date-field', {
    attrs: {
      "extra-classes": "form-control"
    },
    model: {
      value: (_vm.report.date_issued),
      callback: function($$v) {
        _vm.report.date_issued = $$v
      },
      expression: "report.date_issued"
    }
  })], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Client",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.client_id),
      expression: "report.client_id"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.report.client_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.clients), function(client) {
    return _c('option', {
      domProps: {
        "value": client.id
      }
    }, [_vm._v(_vm._s(client.contact_name) + ", " + _vm._s(client.company))])
  }))]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Report Template",
      "col-class": "col-md-4"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.report.report_template_id),
      expression: "report.report_template_id"
    }],
    staticClass: "form-control",
    attrs: {
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.report.report_template_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.reportTemplates), function(template) {
    return _c('option', {
      domProps: {
        "value": template.id
      }
    }, [_vm._v(_vm._s(template.template_name))])
  }))]), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "pull-right btn btn-success"
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Create")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85e26292","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ReportNew.vue
// module id = 301
// module chunks = 0